import { render, staticRenderFns } from "./ProgramsList.vue?vue&type=template&id=fbabd77c"
import script from "./ProgramsList.vue?vue&type=script&lang=js"
export * from "./ProgramsList.vue?vue&type=script&lang=js"
import style0 from "./ProgramsList.vue?vue&type=style&index=0&id=fbabd77c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports